import { DedicatedDriverPreferencesOutput } from '@allocab/allocab-dedicated-driver-types';

import { weekD } from './utils';

type Props = {
  driverPreferenceData: DedicatedDriverPreferencesOutput | undefined;
};

const getProgress = (hours: number, minutes: number) => {
  const res = Math.round(((hours * 60 + minutes) / 1440) * 100);
  return Math.min(Math.max(0, res), 100);
};

export const DriverPreferencesDiagram = ({ driverPreferenceData }: Props) => {
  return (
    <div className="dark:bg-gray-700 dark:border-gray-600 border rounded-lg p-2 space-y-1 h-96 w-full">
      <div className="grid grid-cols-7 text-center h-full">
        {weekD.map(dayz => {
          return (
            <div className="h-full flex flex-col gap-2" key={`${dayz.label}-${dayz.value}`}>
              <div className="hidden lg:block">{dayz.label}</div>
              <div className="block lg:hidden">{dayz.label.substring(0, 3)}</div>
              <div className="dark:border-gray-600 border relative flex-1">
                {driverPreferenceData?.preferences?.[dayz.value]?.map((slot, index) => {
                  return (
                    <div
                      key={index}
                      className={`bg-green-500  absolute left-0 right-0`}
                      style={{
                        top: `${getProgress(slot.start.hours, slot.start.minutes)}%`,
                        bottom: `${100 - getProgress(slot.end.hours, slot.end.minutes)}%`,
                      }}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
